<template>
  <div class="w-full bg-gray-200">

      <FlashMessages></FlashMessages>
      
      
      <div class="bg-white overflow-hidden shadow sm:rounded-lg mx-auto md:w-1/2">
          <div class="bg-indigo-600 px-4 py-5 border-b border-gray-200 sm:px-6">
              <h3 v-if="driver.onboarded===0" class="text-lg leading-6 font-medium text-white">

                  {{ _("Let's start with filling your driver profile below") }}
              </h3>

              <h3 v-else class="text-lg leading-6 font-medium text-white">
                  {{ _("Your details are already saved and locked.") }}
              </h3>
          </div>
          
          <div class="px-4 py-5 sm:p-6">
              <div class="space-y-6 sm:space-y-5">
                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          {{ _("Phone") }}
                      </label>
                      <div class="mt-1 sm:mt-0 sm:col-span-2">
                          {{ driver.phone }}
                      </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <TextField v-if="driver.onboarded ===0" :label="_('First Name')" v-model="driver.first_name"></TextField>
                      <div v-else>
                          <div class="flex justify-between">
                              <label class="block text-sm font-medium text-gray-700">
                                  {{ _("First Name") }}
                              </label>
                          </div>
                          <div class="mt-1">
                                {{ driver.first_name }}
                          </div>
                      </div>
                  </div>
                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <TextField v-if="driver.onboarded ===0" :label="_('Last Name')" v-model="driver.last_name"></TextField>
                      <div v-else>
                          <div class="flex justify-between">
                              <label class="block text-sm font-medium text-gray-700">
                                  {{ _("Last Name") }}
                              </label>
                          </div>
                          <div class="mt-1">
                              {{ driver.last_name }}
                          </div>
                      </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                          {{ _('Mailing Address') }}
                      </label>
                      <div class="mt-1 sm:mt-0 sm:col-span-2">

                          <gmap-autocomplete  v-if="driver.onboarded ===0" class="px-4 py-4 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                 :placeholder="_('Enter your address here')"
                                 @place_changed="getAddressData">
                          </gmap-autocomplete>

                          <div v-else>
                             
                              <div class="mt-1">
                                  {{ driver.address }}
                              </div>
                          </div>
                      </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <TextField  v-if="driver.onboarded ===0" :label="_('Appartment / Suite #')" :extra="_('(optional)')" v-model="driver.appartment"></TextField>

                      <div v-else>
                          <div class="flex justify-between">
                              <label class="block text-sm font-medium text-gray-700">
                                  {{ _("Appartment / Suite #") }}
                              </label>
                          </div>
                          <div class="mt-1">
                              {{ driver.appartment }}
                          </div>
                      </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <TextField  v-if="driver.onboarded ===0" :label="_('GST')"  :extra="_('(optional)')" v-model="driver.gst"></TextField>

                      <div v-else>
                          <div class="flex justify-between">
                              <label class="block text-sm font-medium text-gray-700">
                                  {{ _("GST") }}
                              </label>
                          </div>
                          <div class="mt-1">
                              {{ driver.gst }}
                          </div>
                      </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <TextField v-if="driver.onboarded ===0" :label="_('QST')"  extra="(optionnel)" v-model="driver.qst"></TextField>
                      <div v-else>
                          <div class="flex justify-between">
                              <label class="block text-sm font-medium text-gray-700">
                                  {{ _("QST") }}
                              </label>
                          </div>
                          <div class="mt-1">
                              {{ driver.qst }}
                          </div>
                      </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      
                      <div class="mt-1 sm:mt-0 sm:col-span-2">
                          <FileInput  v-if="driver.onboarded ===0" v-model="photo" type="file" :app_locale="app_locale" accept="image/*" :label="_('Driver License Photo ID')"></FileInput>

                          <div v-else>
                              <div class="flex justify-between">
                                  <label class="block text-sm font-medium text-gray-700">
                                      {{ _("Driver License Photo ID") }}
                                  </label>
                              </div>
                              <div class="mt-1">
                                  <img :src="driver.license" class="h-64">
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                      <label>
                          <input  v-if="driver.onboarded ===0" type="checkbox" v-model="consent" class="mr-1" />
                          <input  v-else type="checkbox" checked disabled class="mr-1" />
                          {{ _("I agree that Livro.ca will issue invoices to merchants on my behalf as a self-employed courrier service. I certify that I am eligible to work in Canada, that I have a valid driver's license and appropriate insurance. I am solely responsible for my income and do not hold Livro.ca responsible for any tax related conformities or legal implications.") }}
                      </label>
                      
                  </div>
                  
                  
                  <div v-if="driver.onboarded === 0" @click="submit" :class="consent?'bg-indigo-600 cursor-pointer':'bg-indigo-200'" class="w-full text-white font-bold text-center py-3 ">
                      {{ _('Save Details') }}
                  </div>
                  
              </div>
          </div>
      </div>

          
      </div>
</template>

<script>
import FlashMessages from "../Shared/FlashMessages";
import PhoneFormatter from "../Shared/PhoneFormatter";
import {lang} from "../lang";
import IconClockOutline from "../../icons/outline/IconClockOutline";
import TextField from "../Shared/TextField";
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import FileInput from "../Shared/FileInput";
export default {
  name: "DriverOffline",
    components: {FileInput, TextField, IconClockOutline, PhoneFormatter, VueGoogleAutocomplete, FlashMessages},
    props: [
        'app_locale',
        'driver',
    ],
    data() {
        return {
            grabbing: false,
            photo: null,
            consent: false,
            address: this.driver.address ?? '',
        }
    },
    
    methods: {

        getAddressData(addressData, placeResultData, id) {

            if (!addressData) {
                return;
            }
            let address = addressData.formatted_address;

            let components = {};
            if (addressData.address_components) {
                addressData.address_components.forEach(entry => {
                    entry.types.forEach(type => {
                        components[type] = entry.long_name;
                    })
                })
            }

            // administrative_area_level_1: "Québec"
            // administrative_area_level_3: "Laval"
            // country: "Canada"
            // locality: "Laval"
            // neighborhood: "Champfleury"
            // political: "Canada"
            // postal_code: "H7L 4W6"
            // route: "Boulevard des Oiseaux"
            // street_number: "2410"


            if (components.street_number && components.route && components.locality && components.administrative_area_level_1 && components.country) {
                address = `${components.street_number} ${components.route}, ${components.locality}, ${components.administrative_area_level_1}, ${components.country}`;
            }
            
            this.address = address;
        },
        
        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },


        submit() {
            if (!this.consent || !this.photo) {
                return;
            }
            let data = new FormData()
            data.append('driver', this.driver.id)
            data.append('first_name', this.driver.first_name ?? '')
            data.append('last_name', this.driver.last_name ?? '')
            data.append('address', this.address ?? '')
            data.append('appartment', this.driver.appartment)
            data.append('gst', this.driver.gst ?? '')
            data.append('qst', this.driver.qst ?? '')
            data.append('app_locale', this.app_locale)
            data.append('consent', this.consent)
            data.append('photo', this.photo ?? '')

            this.$inertia.post(this.$route('driver.submit-profile'), data, {
                preserveState: true,
            });

        },
        
    }
}
</script>

<style scoped>

</style>
